import { useCallback, useEffect, useState } from 'react';

import { organizationService } from '@/services';
import type { OrganizationStats } from '@/types';

interface UseOrganizationStatsResult {
  readonly stats: OrganizationStats | null;
  readonly loading: boolean;
  readonly error: string | null;
  readonly refetch: () => Promise<void>;
}

export function useOrganizationStats(): UseOrganizationStatsResult {
  const [stats, setStats] = useState<OrganizationStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await organizationService.fetchStats();
      setStats(data);
    } catch (err) {
      const message =
        err instanceof Error
          ? err.message
          : 'Failed to fetch organization stats';
      setError(message);
      console.error('Error fetching organization stats:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return {
    stats,
    loading,
    error,
    refetch: fetchData,
  };
}
